import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const CalendarWithStar = (props: Icon): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 16 16"
    style={{ ...style(props.size, props.height), ...props.style }}
    className={props.className}
  >
    <defs>
      <path
        id="calendar-with-star-a"
        d="M16 4c.342 0 .624.257.662.589l.005.078-.001.666H18a2 2 0 011.995 1.851l.005.15V18a2 2 0 01-2 2H6a2 2 0 01-2-2V7.333a2 2 0 012-2h1.333v-.666a.667.667 0 011.33-.078l.004.078-.001.666h6.667v-.666c0-.369.299-.667.667-.667zM7.333 6.666H6a.667.667 0 00-.667.667V18c0 .368.299.667.667.667h12a.667.667 0 00.667-.667V7.333A.667.667 0 0018 6.667l-1.334-.001V8a.667.667 0 01-1.328.078L15.333 8V6.666H8.666V8a.667.667 0 01-1.328.078L7.333 8V6.666zM12 10c.342 0 .624.257.662.589l.005.078-.001 1.885 1.795-.582a.667.667 0 01.484 1.24l-.072.028-1.795.583 1.11 1.526a.667.667 0 01-1.026.848l-.053-.064L12 14.604l-1.109 1.527a.667.667 0 01-1.123-.714l.045-.07 1.107-1.526-1.793-.583a.667.667 0 01.337-1.288l.075.02 1.794.582v-1.885c0-.369.299-.667.667-.667z"
      ></path>
    </defs>
    <g fill="none" fillRule="evenodd" transform="translate(-4 -4)">
      <mask id="calendar-with-star-b" fill="#fff">
        <use xlinkHref="#calendar-with-star-a"></use>
      </mask>
      <g
        fill={props.color || theme.palette.grey600}
        mask="url(#calendar-with-star-b)"
      >
        <path d="M0 0h24v24H0z"></path>
      </g>
    </g>
  </svg>
);
